import React from "react";
import { Box, Typography, Tab, Tabs } from "@mui/material";
import Title from "./Title";
import Sentence from "./Sentence";
import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";

import teru from "../assets/img/profile/profile_teru_3.webp";
import bustup_teru from "../assets/img/profile/bustup_teru3.webp";

import reno from "../assets/img/profile/profile_reno.webp";
import bustup_reno from "../assets/img/profile/bustup_reno.webp";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PersonalProfile = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#fbf9f3" }}
    >
      <Box
        sx={{
          padding: 4,
          display: "inline-block",
          textAlign: "center",
          margin: "0 auto",
        }}
      >
        <Title>Personal profile</Title>

        <Box sx={{ p: 2 }}></Box>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="fullWidth"
              centered
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#ff8a65", // ← お好きな色に変更
                },
              }}
            >
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={1}>
                    <Avatar
                      alt="teru"
                      src={bustup_teru}
                      sx={{ width: 36, height: 36 }}
                    />
                    <Typography>輝征</Typography>
                  </Box>
                }
                {...a11yProps(0)}
                sx={{
                  color: "gray", // 通常時の色
                  "&.Mui-selected": {
                    color: "#ff8a65", // 選択時の色
                    fontWeight: "bold",
                  },
                }}
              />

              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={1}>
                    <Avatar
                      alt="reno"
                      src={bustup_reno}
                      sx={{ width: 36, height: 36 }}
                    />
                    <Typography>玲乃</Typography>
                  </Box>
                }
                {...a11yProps(1)}
                sx={{
                  color: "gray", // 通常時の色
                  "&.Mui-selected": {
                    color: "#ff8a65", // 選択時の色
                    fontWeight: "bold",
                  },
                }}
              />
            </Tabs>
          </Box>

          <CustomTabPanel value={value} index={1}>
            <img
              src={reno}
              alt={`玲乃の写真`}
              style={{
                width: "42%",
                maxWidth: "100vw",
                height: "auto",
              }}
            />

            <Box sx={{ p: 2 }} />

            <Sentence>
              輝征の家に我がもの顔で住みついた26歳
              <br />
              お茶目な面が多いが 着実に計画を進める
              <br />
              したたかさも兼ね備えている
              <br />
            </Sentence>
            {/* <Sentence>
              プロポーズをされる前から結婚式の
              <br />
              見積もりを作成したり
              <br />
              まだ見ぬマイホームの間取りを考えたりと
              <br />
              輝征との未来に妄想は膨らむばかり
              <br />
            </Sentence> */}
            <Sentence>
              食べることが何より大好きで
              <br />
              カフェに行っては輝征の分まで食べたりと
              <br />
              食い意地が止まらない
              <br />
              結婚式に向けて何度目かのダイエットを開始しており
              <br />
              輝征が深夜に食べるラーメンに
              <br />
              歯を食いしばって我慢はしているが・・・？
              <br />
            </Sentence>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={0}>
            <img
              src={teru}
              alt={`輝征の写真`}
              style={{
                width: "35%",
                maxWidth: "100vw",
                height: "auto",
              }}
            />

            <Box sx={{ p: 2 }} />
            <Sentence>
              都内で働くITエンジニア26歳 <br />
              無表情でクールに見えるが 毎日遊び足りておらず <br />
              寝る直前にでんぐり返しや倒立を始める <br />
            </Sentence>
            <Sentence>
              一人暮らしを始めて1年で家を乗っ取られるが
              <br />
              最愛の玲乃と過ごす毎日をとても幸せに感じて
              <br />
              不満を抱いている様子はない <br />
              飲み会に行くことも滅多になく <br />
              玲乃といる時間を大切にしており愛情深い <br />
            </Sentence>
          </CustomTabPanel>
        </Box>
      </Box>
    </Box>
  );
};

export default PersonalProfile;
